// Mirrors EfoDayRules; the backend remains authoritative for every write.
const transitions = {
  requires_reconciliation: ['reportable', 'deleted'],
  reportable: ['reported', 'requires_reconciliation', 'deleted'],
  reported: ['to_be_deleted', 'work_time_recorded'],
  work_time_recorded: ['paid', 'to_be_deleted'],
  paid: ['to_be_deleted'],
  to_be_deleted: ['deleted_in_time', 'deleted_late', 'reported'],
};
export const availableEfoStatuses = rows => {
  if (!rows.length) return [];
  const current = rows.map(row => row.simplified_employment_status_enum || 'requires_reconciliation');
  const candidates = [current[0], ...(transitions[current[0]] || [])];
  return candidates.filter(to => current.every(from => from === to || (transitions[from] || []).includes(to)) && current.some(from => from !== to));
};
